import classNames from "classnames";
import { Fragment } from "react";

export type HeroHeadingType = {
  text: string;
  highlight?: boolean;
  lineBreak?: boolean;
}[];

type HeroHeadingPropsType = {
  heading: HeroHeadingType;
};

const HeroHeading = ({ heading }: HeroHeadingPropsType) => {
  if (heading?.length > 0)
    return (
      <h1
        className={classNames(
          "text-title1 font-semibold text-grey-4 sm:text-64 sm:font-normal"
        )}
      >
        {heading.map(({ text, highlight, lineBreak }) => {
          return (
            <Fragment key={text}>
              {highlight ? (
                <span className="text-purple-3 sm:font-bold">{text}</span>
              ) : (
                text
              )}
              {lineBreak && <br />}
            </Fragment>
          );
        })}
      </h1>
    );
  else return null;
};

export default HeroHeading;
